import { BackToDashboardButtonController as controller } from './back-to-dashboard-button.controller';
import template from './back-to-dashboard-button.html';
import './back-to-dashboard-button.global.css';

export const BackToDashboardButtonComponent = {
  controller,
  template,
};
